wrapRequestOptions